import api from './api';

const signalementService = {
  // Créer un signalement
  create: (data) => {
    return api.post('/signalements', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Routes admin
  admin: {
    getAll: (params = {}) => {
      return api.get('/admin/signalements', { params });
    },

    getById: (id) => {
      return api.get(`/admin/signalements/${id}`);
    },

    update: (id, data) => {
      return api.put(`/admin/signalements/${id}`, data);
    },

    delete: (id) => {
      return api.delete(`/admin/signalements/${id}`);
    },

    marquerCommeTraite: (id) => {
      return api.post(`/admin/signalements/${id}/traiter`);
    },

    assignerPriorite: (id, priorite) => {
      return api.post(`/admin/signalements/${id}/priorite`, { priorite });
    },

    getStatistiques: () => {
      return api.get('/admin/signalements/statistiques');
    }
  }
};

export default signalementService;